import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-FormDesignerPalette',
	title: 'c-FormDesignerPalette__title',
	list: {
		container: 'c-FormDesignerPalette__list',
	},
	field: {
		container: 'c-FormDesignerPalette__field',
		title: 'c-FormDesignerPalette__title',
		isActive: 'c-FormDesignerPalette--is-active',
	},
};

export const Style = {
	[CSS.list.container]: {
		display: 'flex',
		'flex-wrap': 'wrap',
		[`& .${CSS.field.container}:hover`]: {
			cursor: 'pointer',
			'box-shadow': DefaultTheme.shadow.box.dp2,
			'background-color': DefaultTheme.font.color.divider,
		},
	},
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		'flex-direction': 'column',
		'margin-top': DefaultTheme.space(2),
	},
	[CSS.field.container]: {
		width: DefaultTheme.space(25),
		padding: DefaultTheme.space(3) + ' 0',
		'text-align': 'center',
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'flex-direction': 'column',
	},
	[CSS.field.title]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.field.isActive]: {
		color: DefaultTheme.font.color.link,
	},
};
